/**
 * @desc 标记异常
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationMaster.signException.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/signException`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
